module.exports = __webpack_public_path__ + "static/media/bn_6.7d473943.png";